div.dialogHeader {
	display: flex;
	border-image: linear-gradient(
			to right,
			#8f3a5b 10%,
			#be3c44 10%,
			#be3c44 20%,
			#de7441 20%,
			#de7441 30%,
			#f1b945 30%,
			#f1b945 40%,
			#f9e658 40%,
			#f9e658 50%,
			#e091b8 50%,
			#e091b8 60%,
			#793883 60%,
			#793883 70%,
			#303786 70%,
			#303786 80%,
			#6ac1e3 80%,
			#6ac1e3 90%,
			#ced655 90%
		)
		10;
	border-bottom: 7px solid;
	padding: 0;
}

h2.dialogTitle {
	flex: 1;
	font-style: normal;
	font-weight: normal;
	margin: 24px;
	font-size: 19.84px;
	line-height: 18px;
}

.dialogTitle.center {
	text-align: center;
}

.dialogFooter {
	border-top: 1px solid #676e79;
}

button.closeButton {
	align-self: start;
	color: grey;
	font-size: 30px;
}

.dialogHeader + div.dialogBody {
	line-height: 1.2;
	padding-top: 20px;
}

.mainDescription {
	font-size: 18px;
	margin-bottom: 20px;
}

.messageDialogContent {
	composes: dialogBody;
	font-size: 17px;
	padding-bottom: 10px;
}
